module.exports = __webpack_public_path__ + "static/media/Apollo-Portal_Login_Logo.b6043c32.png";